export const bootstrapAuthTokensFromUrl = (): void => {
  const searchParams = new URLSearchParams(window.location.search)
  const jwtFromUrl = searchParams.get(`jwt`)

  if (!jwtFromUrl) return

  if (jwtFromUrl) {
    window.localStorage.setItem(`jwt`, jwtFromUrl)
    searchParams.delete(`jwt`)
  }

  const updatedSearch = searchParams.toString()
  const updatedUrl = `${window.location.pathname}${updatedSearch ? `?${updatedSearch}` : ``}${window.location.hash}`
  window.history.replaceState({}, ``, updatedUrl)
}
